import * as React from "react";
import type { SVGProps } from "react";
const SvgInstagram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={140}
    height={140}
    fill="none"
    {...props}
  >
    <path
      fill="url(#instagram_svg__a)"
      d="M60 120c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60"
    />
    <path
      fill="#fff"
      d="M60.002 28c-8.69 0-9.781.038-13.195.193-3.406.156-5.732.696-7.766 1.487-2.105.817-3.89 1.91-5.669 3.69-1.78 1.779-2.873 3.564-3.693 5.668-.794 2.035-1.334 4.361-1.487 7.767C28.04 50.218 28 51.309 28 60c0 8.69.039 9.778.193 13.191.157 3.407.696 5.732 1.487 7.767.818 2.105 1.911 3.89 3.69 5.669 1.779 1.78 3.564 2.876 5.667 3.693 2.037.791 4.363 1.33 7.769 1.487 3.413.155 4.503.193 13.193.193 8.691 0 9.779-.038 13.192-.193 3.407-.156 5.735-.696 7.77-1.487 2.105-.817 3.888-1.913 5.666-3.693 1.78-1.779 2.873-3.564 3.693-5.668.787-2.036 1.327-4.362 1.487-7.767C91.96 69.779 92 68.691 92 60s-.04-9.781-.193-13.195c-.16-3.406-.7-5.732-1.487-7.766-.82-2.105-1.913-3.89-3.693-5.669-1.78-1.78-3.56-2.873-5.667-3.69-2.04-.791-4.367-1.33-7.773-1.487-3.414-.155-4.5-.193-13.194-.193zm-2.87 5.767c.852-.002 1.802 0 2.87 0 8.544 0 9.557.03 12.931.184 3.12.142 4.813.664 5.941 1.102 1.494.58 2.559 1.273 3.678 2.393 1.12 1.12 1.813 2.187 2.395 3.68.438 1.127.96 2.82 1.102 5.94.153 3.373.186 4.387.186 12.927s-.033 9.553-.186 12.926c-.143 3.12-.664 4.814-1.102 5.94-.58 1.494-1.275 2.557-2.395 3.676s-2.184 1.814-3.678 2.394c-1.126.44-2.82.96-5.94 1.102-3.374.154-4.388.187-12.932.187s-9.557-.033-12.93-.187c-3.12-.144-4.814-.665-5.943-1.103-1.493-.58-2.56-1.273-3.68-2.393s-1.813-2.184-2.394-3.678c-.438-1.127-.96-2.82-1.102-5.94-.154-3.374-.184-4.387-.184-12.932s.03-9.554.184-12.927c.142-3.12.664-4.813 1.102-5.941.58-1.494 1.274-2.56 2.394-3.68s2.187-1.814 3.68-2.395c1.129-.44 2.823-.96 5.943-1.103 2.952-.134 4.096-.174 10.06-.18zm19.952 5.313a3.84 3.84 0 1 0 0 7.682 3.84 3.84 0 0 0 0-7.683zm-17.082 4.487c-9.075 0-16.433 7.358-16.433 16.433s7.358 16.43 16.433 16.43c9.076 0 16.432-7.355 16.432-16.43s-7.357-16.433-16.432-16.433m0 5.766c5.891 0 10.667 4.776 10.667 10.667 0 5.89-4.776 10.667-10.667 10.667S49.336 65.89 49.336 60s4.775-10.667 10.666-10.667"
    />
    <defs>
      <linearGradient
        id="instagram_svg__a"
        x1={-10.16}
        x2={119.797}
        y1={143.817}
        y2={21.092}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD521" />
        <stop offset={0.055} stopColor="#FFD020" />
        <stop offset={0.124} stopColor="#FEC01E" />
        <stop offset={0.2} stopColor="#FCA71B" />
        <stop offset={0.282} stopColor="#FA8316" />
        <stop offset={0.368} stopColor="#F85510" />
        <stop offset={0.456} stopColor="#F51E09" />
        <stop offset={0.5} stopColor="#F30005" />
        <stop offset={0.503} stopColor="#F20007" />
        <stop offset={0.597} stopColor="#E1003B" />
        <stop offset={0.688} stopColor="#D30067" />
        <stop offset={0.776} stopColor="#C70088" />
        <stop offset={0.859} stopColor="#BF00A0" />
        <stop offset={0.936} stopColor="#BB00AF" />
        <stop offset={1} stopColor="#B900B4" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgInstagram;
